import LotteryNumlotStatsContainer from "../../components/lottery/containers/LotteryNumlotStatsContainer";
import LotteryNumlotStatsTemplate from "../../components/lottery/templates/LotteryNumlotStatsTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Loto7Stats() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="lt7" />
      <section className="min-h-screen">
        <LotteryNumlotStatsContainer lotteryKey="lt7" Template={LotteryNumlotStatsTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="lt7" />
    </>
  );
}
export default Loto7Stats;